<ra-modal [size]="'large'" [title]="('document.edit.listSession.title' | translate)" (close)="close.emit()">

    @let folders = folderDestinations();
    @let sections = sectionDestinations();

    @if (loading())
    {
        <ra-loading
            [marginTop]="32"
            [message]="('document.edit.listSession.moving' | translate)"
        />
    }
    @else
    {
        <!-- Nova seção: criada logo depois da atual. Com um título na seleção, o nome já
             vem dele (e a seção não ganha outro título). -->
        <div class="new-section">
            <p class="new-section-title">{{ 'document.edit.listSession.newSectionTitle' | translate }}</p>
            <div class="new-section-row">
                <input
                    type="text"
                    class="new-section-input"
                    maxlength="200"
                    autocomplete="off"
                    [value]="newSectionName()"
                    [placeholder]="'document.edit.listSession.newSectionPlaceholder' | translate"
                    (input)="newSectionName.set($any($event.target).value)"
                    (keydown.enter)="moveToNewSection()" />
                <ra-button
                    [type]="'primary'"
                    [icon]="'add'"
                    [label]="'document.edit.listSession.newSectionButton' | translate"
                    (click)="moveToNewSection()" />
            </div>
        </div>

        @if (folders.length === 0 && sections.length === 0)
        {
            <p class="ra-label-s content-secondary no-other-sections">
                {{ 'document.edit.listSession.emptyMessage' | translate }}
            </p>
        }
        @else
        {
            <p class="ra-label-s content-secondary description-action">
                {{ 'document.edit.listSession.hint' | translate }}
            </p>

            <!-- Pastas (só aparecem em documentos com checklist) -->
            @if (folders.length > 0)
            {
                <p class="group-label">{{ 'document.edit.listSession.foldersGroup' | translate }}</p>

                <div class="container-sessions-list">
                    @for (dest of folders; track dest.key) {
                        <ra-fillet
                            [icon]="'folder'"
                            [title]="dest.label"
                            [description]="dest.sublabel"
                            [clickMessage]="('document.edit.listSession.clickToMoveFolder' | translate)"
                            (click)="move(dest)"
                        />
                    }
                </div>
            }

            <!-- Seções -->
            @if (sections.length > 0)
            {
                @if (folders.length > 0)
                {
                    <p class="group-label">{{ 'document.edit.listSession.sectionsGroup' | translate }}</p>
                }

                <div class="container-sessions-list">
                    @for (dest of sections; track dest.key) {
                        <ra-fillet
                            [icon]="'document-normal'"
                            [title]="dest.label"
                            [description]="dest.sublabel"
                            [clickMessage]="('document.edit.listSession.clickToMove' | translate)"
                            (click)="move(dest)"
                        />
                    }
                </div>
            }
        }
    }
</ra-modal>
